module.exports = __webpack_public_path__ + "img/1.93db7c11.png";